export const secondsToMinutes = (seconds) => {
  return Math.round((seconds / 60) * 100) / 100;
};

export const formatResultTime = (time) => {
  const minutes = Math.floor(time / 60);
  const seconds = time - minutes * 60;

  return minutes + ':' + seconds + ' minutes';
};
